export default __webpack_public_path__ + "static/media/exclamation-triangle-solid.62c08da3.svg";